import React, { useEffect, useRef } from 'react';
import { withTracking } from '../../../Services/Monitoring/ApplicationInsights';
import AppContainer from '../../Container/AppContainer';
import BodyContainer from '../../Container/BodyContainer';
import CustomImg from '../../CustomImage/CustomImg';
import Header from '../../Header/HeaderRefactor';
import CustomTypography, {
    TypographyType,
} from '../../Typography/CustomTypography';
import CustomButton from '../../Button/CustomButton';
import { ButtonType } from '../../Button/ButtonType';
import { ButtonProps } from '@mui/material';
import CustomDialog from '../CustomDialog';
import usePageNotFoundDialogResource from './PageNotFoundDialogResourceHook';
import usePageNotFoundDialogHandler from './PageNotFoundDialogHandlerHook';
import './PageNotFoundDialog.scss';
import useLoading from '../../Spinner/PageLoadSpinner';

function PageNotFoundDialog() {
    const { header, image, dialogTitle, dialogMessage, backButton } =
        usePageNotFoundDialogResource();
    const [spinner, setLoading, loading] = useLoading();
    const { backToOrionNow } = usePageNotFoundDialogHandler();
    const isComponentMounted = useRef(true);
    const buttonConfig: ButtonProps = {
        id: backButton.id,
        onClick: backToOrionNow,
        children: backButton.label,
    };

    useEffect(() => {
        const handleRedirect = async () => {
            setLoading(false);
        };

        if (isComponentMounted.current) {
            (async function init() {
                await handleRedirect();
            })();
        }
        return () => {
            isComponentMounted.current = false;
        };
    });

    return loading ? (
        spinner
    ) : (
        <CustomDialog fullScreen open={true}>
            <AppContainer>
                <Header headerContent={header} />
                <BodyContainer>
                    <CustomImg
                        imgType={'large'}
                        id={image.id}
                        src={image.src}
                        alt={image.alt}
                        className={'pageNotFoundImageArea'}
                    />
                    <CustomTypography
                        id={dialogTitle.id}
                        type={TypographyType.notoSansBody18px}
                        text={dialogTitle.text}
                        className={'pageNotFoundTextArea'}
                    />
                    <CustomTypography
                        id={dialogMessage.id}
                        type={TypographyType.notoSansBody16px}
                        text={dialogMessage.text}
                        className={'pageNotFoundTextArea'}
                    />
                </BodyContainer>
                <CustomButton
                    {...buttonConfig}
                    buttonType={ButtonType.Primary}
                />
            </AppContainer>
        </CustomDialog>
    );
}

export default withTracking(PageNotFoundDialog);
